import { RestError } from "../../services/rest-service/RestService";
import { useQuery, useQueryClient } from "react-query";
import { IOfflineData } from "../../services/offline-data-service/Models";
import OfflineDataService  from "../../services/offline-data-service/OfflineDataService";


import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseOfflineDataQueryParameters = {
    customerID: number
} & BaseUseQueryParameters<IOfflineData>

export function useOfflineData(params: UseOfflineDataQueryParameters) {
    const queryClient = useQueryClient();
    
    return useQuery<IOfflineData | undefined, RestError>(
        keys.data(params.customerID),
        ({ signal }) => {
            if (params.customerID) {
                return OfflineDataService.getOfflineData(params.customerID, signal);
            }

        },
        {
            // limit refresh to occur every hour, the data will be refreshed when logging in and also 
            // at offline/online transistions
            staleTime: (60 * 60) * 1000,
            refetchOnMount: false,
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
            enabled: params.enabled,
            onError: params.onError,
            onSuccess: params.onSuccess,
            onSettled: () => {
                // anytime the offline data is fetched, invalidate the offline configuration data since it is
                // constructed from the offline data call
                queryClient.invalidateQueries(keys.configuration());
            }
        }
    );
}
